/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

import './button.css';
import './button_theme_alfa-on-color.css';
import './button_theme_alfa-on-white.css';

export { default } from './button';
